export default "__VITE_ASSET__$jpHbTFt__"